import { Component, Injector, OnInit } from '@angular/core';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.css']
})
export class UpcomingComponent implements OnInit {
  env = environment
  public message: any = 'Welcome To Our Exchange'
  public _pusher!: PusherService;

  constructor(public sharedService: SharedService, private _common: CommonService, private injector: Injector) {
    this.message = (localStorage.getItem(`${this.env.panel}marquee`)) ? localStorage.getItem(`${this.env.panel}marquee`) : this.message;
    // console.log(this.message);

    this.sharedService.sharedMessage.subscribe((data: any) => {
      if (data != '')
        this.message = data;
    });

    if (this._common.getToken()) {
      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.globalMsgUpdate().subscribe(res => {
        if (res)
          this.message = res.message;
      });
    }
  }

  ngOnInit(): void {
  }

}
